// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Btn from "../../html/Btn.js";
import * as Buhta_cabinet__Control from "../../../grpc/Control.js";
import * as Buhta_cabinet__Field from "../../html/Field.js";
import * as Buhta_cabinet__LogoMaker from "../../molecules/LogoMaker.js";
import * as Buhta_cabinet__Org from "../../../models/Org.js";
import * as Buhta_cabinet__PhoneField from "../../html/PhoneField.js";
import * as Buhta_cabinet__RadioButton from "../../html/RadioButton.js";
import * as Buhta_cabinet__ToastSender from "../../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as Formating from "../../../../../../packages/util/lib/Formating.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function OrgSettingsGeneral(Props) {
  let org = Props.org;
  const match = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match[1];
  const match$1 = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match$1[0];
  const match$2 = React.useState(function () {
        return "";
      });
  const setName = match$2[1];
  const name = match$2[0];
  const match$3 = React.useState(function () {
        return false;
      });
  const setResident = match$3[1];
  const resident = match$3[0];
  const match$4 = React.useState(function () {
        return "";
      });
  const setAddress = match$4[1];
  const address = match$4[0];
  const match$5 = React.useState(function () {
        return "";
      });
  const setPhone = match$5[1];
  const phone = match$5[0];
  const match$6 = React.useState(function () {
        return "";
      });
  const setEmail = match$6[1];
  const email = match$6[0];
  const match$7 = React.useState(function () {
        return 1;
      });
  const setRows = match$7[1];
  const func = Buhta_cabinet__Control.PropInformationService.view;
  const match$8 = Buhta_core__GrpcState.useModel((function (param) {
          return Curry._2(func, param, /* [] */0);
        }), undefined);
  const dispatchProp = match$8[1];
  const settingsProp = match$8[0];
  const arg = org.id;
  const func$1 = Buhta_cabinet__Control.OrgService.view;
  const match$9 = Buhta_core__GrpcState.useModel((function (param) {
          return Curry._3(func$1, param, /* [] */0, arg);
        }), undefined);
  const dispatchOrg = match$9[1];
  const settingsOrg = match$9[0];
  React.useEffect((function () {
          Curry._2(dispatchProp, undefined, undefined);
          Curry._2(dispatchOrg, undefined, undefined);
        }), []);
  React.useEffect((function () {
          if (typeof settingsProp !== "string" && settingsProp.NAME === "Data") {
            const prop = settingsProp.VAL;
            Curry._1(setName, (function (param) {
                    return prop.name;
                  }));
            Curry._1(setAddress, (function (param) {
                    return prop.address;
                  }));
            Curry._1(setResident, (function (param) {
                    return prop.resident;
                  }));
            Curry._1(setPhone, (function (param) {
                    return prop.phone;
                  }));
            Curry._1(setEmail, (function (param) {
                    return prop.email;
                  }));
            Curry._1(setRows, (function (param) {
                    return (prop.address.length / 65 | 0) + 1 | 0;
                  }));
          }
          
        }), [settingsProp]);
  const nameTrimmed = function (name) {
    const name$1 = name.replace(/[^a-zA-Z0-9Ёёа-яА-Я-әғқңөұүһіІі.,\s-]/g, "").trim();
    return Belt__Belt_List.reduce({
                  hd: "ип",
                  tl: {
                    hd: "тоо",
                    tl: {
                      hd: "too",
                      tl: {
                        hd: "жшс",
                        tl: {
                          hd: "жшc",
                          tl: {
                            hd: "жк",
                            tl: {
                              hd: "жеке кәсіпкер",
                              tl: {
                                hd: "жауапкершілігі шектеулі серіктестік",
                                tl: {
                                  hd: "товарищество с ограниченной ответственностью",
                                  tl: {
                                    hd: "индивидуальный предприниматель",
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }, name$1, (function (name, currentNameToDelete) {
                    if (name.toLowerCase().indexOf(currentNameToDelete, undefined) === 0) {
                      return name.slice(currentNameToDelete.length, undefined);
                    } else {
                      return name;
                    }
                  })).trim();
  };
  const saveSettings = function (ev) {
    ev.preventDefault();
    const propData = {
      id: 0,
      name: name,
      address: address,
      resident: resident,
      email: email,
      phone: phone,
      create_time: undefined
    };
    const __x = Buhta_cabinet__Control.PropInformationService.update(tenant, propData);
    $$Promise.get(__x, (function (result) {
            if (result.TAG === /* Ok */0) {
              return Curry._1(dispatchToasts, {
                          TAG: /* Add */0,
                          _0: {
                            id: Buhta_core__Toast.generateId(undefined),
                            text: "Настройки сохранены",
                            kind: "success",
                            onClick: (function (param) {
                                
                              })
                          }
                        });
            } else {
              return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при сохранении");
            }
          }));
  };
  let tmp;
  if (typeof settingsProp === "string" || !(settingsProp.NAME === "Data" && !(typeof settingsOrg === "string" || settingsOrg.NAME !== "Data"))) {
    tmp = null;
  } else {
    const settingsOrg$1 = settingsOrg.VAL;
    tmp = JsxRuntime.jsxs(React.Fragment, {
          children: [
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_components__Text.H2.make, {
                                  className: "max-w-[386px] mb-4",
                                  children: settingsOrg$1.name
                                }),
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                  className: "text-asphalt",
                                  children: Buhta_cabinet__Org.Type.toString(settingsOrg$1["type'"])
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: "text-asphalt",
                                          children: "ИИН/БИН:"
                                        }),
                                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          children: settingsOrg$1.tin
                                        })
                                  ],
                                  className: "flex gap-1 mt-2"
                                })
                          ]
                        }),
                    JsxRuntime.jsx(Buhta_cabinet__LogoMaker.make, {
                          name: nameTrimmed(name),
                          size: "w-20 h-20",
                          textSize: "xxxl"
                        })
                  ],
                  className: "flex justify-between bg-white w-[562px] rounded-md shadow-kkm p-10"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                          label: "Юридическое наименование",
                          type_: "text",
                          name: "name",
                          size: "m",
                          required: true,
                          onChange: (function (value) {
                              Curry._1(setName, (function (param) {
                                      return value;
                                    }));
                            }),
                          value: name
                        }),
                    JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                          className: "mt-6 text-default-gray",
                          children: "Резиденство"
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                  checked: resident,
                                  onChange: (function (param) {
                                      Curry._1(setResident, (function (param) {
                                              return true;
                                            }));
                                    }),
                                  children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        className: "ml-2",
                                        children: "Резидент"
                                      })
                                }),
                            JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                  checked: !resident,
                                  onChange: (function (param) {
                                      Curry._1(setResident, (function (param) {
                                              return false;
                                            }));
                                    }),
                                  children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        className: "ml-2",
                                        children: "Не резидент"
                                      })
                                })
                          ],
                          className: "flex gap-6 mt-4 items-center"
                        }),
                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                          label: "Юридический адрес",
                          type_: "text",
                          name: "address",
                          size: "m",
                          required: true,
                          onChange: (function (value) {
                              Curry._1(setAddress, (function (param) {
                                      return value;
                                    }));
                              Curry._1(setRows, (function (param) {
                                      return (value.length / 65 | 0) + 1 | 0;
                                    }));
                            }),
                          multiline: true,
                          className: "mt-4",
                          value: address,
                          rows: match$7[0]
                        }),
                    JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                          className: "mt-6 text-default-gray",
                          children: "Контакты предприятия"
                        }),
                    JsxRuntime.jsx(Buhta_cabinet__PhoneField.make, {
                          value: Formating.formatPhone(phone),
                          onChange: (function (value) {
                              Curry._1(setPhone, (function (param) {
                                      return value;
                                    }));
                            }),
                          size: "m",
                          className: "mt-4",
                          label: "Номер телефона"
                        }),
                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                          label: "Email",
                          type_: "text",
                          name: "email",
                          size: "m",
                          required: true,
                          onChange: (function (value) {
                              Curry._1(setEmail, (function (param) {
                                      return value;
                                    }));
                            }),
                          className: "mt-4",
                          value: email
                        })
                  ],
                  className: "bg-white w-[562px] rounded-md shadow-kkm p-10 mt-2"
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                        title: "Сохранить",
                        className: "px-6 py-3",
                        type_: "submit"
                      }),
                  className: "w-[562px] flex justify-end mt-6"
                })
          ]
        });
  }
  return JsxRuntime.jsx("form", {
              children: tmp,
              className: "flex flex-col items-center py-6",
              onSubmit: saveSettings
            });
}

const make = OrgSettingsGeneral;

export {
  make ,
}
/* Buhta_cabinet__Btn Not a pure module */
